<template>
	<div class="label-input">
		<label :for="id_">{{ label }}</label>
		<MSelect
			v-model="selected"
			:id="id_"
			:name="name_"
			:attrs="attrs"
			:defaultOption="defaultOption"
			:options="options"
			:disabled="disabled"
			:errors="errors"
		/>
	</div>
</template>

<script>
import merge from 'lodash/merge';
import { createNameFromVModelExpr } from '../../index';
import MSelect from './MSelect';

export default {
	name: 'MLabeledSelect',
	components: { MSelect },
	data() {
		return {
			id_: this.id,
			name_: this.name,
			selected: this.value
		}
	},
	props: merge({}, MSelect.props, { label: { type: String, default: '' } }),
	watch: {
		selected(new_) {
			this.$emit('input', new_);
		}
	},
	created() {
		const id = createNameFromVModelExpr(this);
		const name = this.$vnode.data.model.expression;

		if (id && !this.id_) this.id_ = id;

		if (name && !this.name_) this.name_ = name;
	}
}
</script>

<style scoped></style>
